type Variant = 'serps' | 'product';

export interface BigYellowVoucherProps {
  variant: Variant;
}

interface BannerContent {
  copy: string;
  link: `/${string}`;
  linkText: string;
}

const BANNER_CONTENT: Record<Variant, BannerContent> = {
  serps: {
    copy: 'pre-registered cars',
    link: '/collections/big-yellow-voucher',
    linkText: 'Shop eligible cars',
  },
  product: {
    copy: 'this car',
    link: '/offers',
    linkText: 'Claim your voucher',
  },
};

const BigYellowVoucher = ({ variant }: BigYellowVoucherProps) => {
  const { copy, link, linkText } = BANNER_CONTENT[variant];

  return (
    <div className="big-yellow-voucher ch-rounded--sm ch-display--flex ch-align-items--stretch ch-justify-content--between ch-bg--ac-black">
      <div className="ch-ma--2 ch-display--flex ch-flex-direction--column ch-align-items--start">
        <p className="big-yellow-voucher__copy ch-fw--600 ch-fs--3 sl:ch-fs--5 ch-mb--0 sm:ch-mr--1 ch-color--white ch-lh--heading">
          Get an extra{' '}
          <span className="ch-color--ac-yellow ch-text--nowrap">
            &pound;500 off
          </span>{' '}
          <span className="ch-text--nowrap">{copy}.</span>
        </p>
        <a
          className="ch-color--white ch-fs--1 sl:ch-fs--2 ch-fw--500"
          href={link}
          rel="noreferrer"
          target="_blank"
        >
          {linkText}
        </a>
      </div>
      <div className="ch-display--flex ch-align-items--stretch">
        <div className="big-yellow-voucher__image--car ch-display--none sm:ch-display--block"></div>
        <div className="big-yellow-voucher__image--logo ch-mr--2 sm:ch-mr--3"></div>
      </div>
    </div>
  );
};

export default BigYellowVoucher;
